// TEMPORARY: development-only shortcut to the mechanic's "new request" screen
// (T_Request1) populated with fake data, so its layout can be iterated on
// without needing a real customer request.
//
// To remove: delete this file and the <TestRequestButton/> usages in
// screens/T_Profile2.js and screens/T_Home.js.

import React from 'react';
import { Asset } from 'expo-asset';

import EonnButton from './button';

// Local assets so the fake thumbnails render offline and on every platform.
const localImage = (asset) => Asset.fromModule(asset).uri;

const buildTestConsult = () => ({
  id: 'test-consult-123',
  isTestConsult: true, // T_Request1 uses this to skip SMS / Firebase writes
  status: 'requested',
  desc: 'Engine making strange noise when accelerating',
  c_vehicle: '2018 Honda Civic',
  c_miles: '85,000',
  c_name: 'John Doe',
  c_phone: '+10000000000',
  note: 'The noise started about a week ago and seems to get worse when I press the gas pedal. It\'s most noticeable when going uphill.',
  media: [
    localImage(require('../assets/images/bg1.png')),
    localImage(require('../assets/images/portrait1.png')),
    localImage(require('../assets/images/logo.png')),
  ],
  timeRequested: new Date().getTime() - 5 * 60 * 1000, // 5 minutes ago
});

export default function TestRequestButton({ navigation, style }) {
  return (
    <EonnButton
      navigationProps={navigation}
      white={true}
      style={[{ marginTop: 20, marginBottom: 20 }, style]}
      onPress={() => {
        global.consult = buildTestConsult();
        navigation.navigate('T_Request1');
      }}
    >
      TEST: Job Request
    </EonnButton>
  );
}
